module.exports = __webpack_public_path__ + "static/media/property-managers-5.d0ef60a3.svg";